import { memo } from "react";

import { AssertionsCell } from "./AssertionsCell";

import { ReportCell, ReportColumn } from "@/types/evaluate";

interface LLMAssertionCellProps {
  cell: ReportCell;
  column: ReportColumn;
  isColumnSelected?: boolean;
}

export const LLMAssertionCell = memo<LLMAssertionCellProps>(
  ({ cell, column, isColumnSelected = false }) => {
    if (cell.display_value.type === "boolean") {
      const prompt =
        typeof column.configuration.prompt === "string" &&
        column.configuration.prompt.startsWith("[")
          ? JSON.parse(column.configuration.prompt)[0]
          : column.configuration.prompt;

      // Pass the full detailed object for tooltip (reasoning/citation)
      return (
        <AssertionsCell
          prompt={prompt}
          value={cell.value?.value}
          isColumnSelected={isColumnSelected}
        />
      );
    }

    if (cell.display_value.type === "object") {
      return (
        <AssertionsCell value={cell.display_value.value} isColumnSelected={isColumnSelected} />
      );
    }

    return (
      <div className="flex h-full w-full items-center justify-center p-2 text-xs text-gray-500">
        Unsupported assertion type
      </div>
    );
  },
);
